/* eslint-disable */
export const sumBySourceStepFunction = /* GraphQL */ `
  query SumBySourceStepFunction(
    $clientID: String
    $startDate: String
    $endDate: String
    $includeExclusions: Boolean
    $separateRecurring: Boolean
    $removeTotals: Boolean
    $exportStyledExcelSheet: Boolean
    $userEmail: String
    $aggType: String
    $breakdownPeriod: String
    $downloadRequest: Boolean
  ) {
    sumBySourceStepFunction(
      clientID: $clientID
      startDate: $startDate
      endDate: $endDate
      includeExclusions: $includeExclusions
      separateRecurring: $separateRecurring
      removeTotals: $removeTotals
      exportStyledExcelSheet: $exportStyledExcelSheet
      userEmail: $userEmail
      aggType: $aggType
      breakdownPeriod: $breakdownPeriod
      downloadRequest: $downloadRequest
    )
  }
`;

export const sumBySourceDisplayCacheByClientID = /* GraphQL */ `
  query SumBySourceDisplayCacheByClientID(
    $client_id: String!
  ) {
    sumBySourceDisplayCacheByClientID(
      client_id: $client_id
    ) {
      items {
        client_id
        run_config
        status
        display_data
        errors
        createdAt
        updatedAt
        expiresAt
      }
    }
  }
`;

export const importExclusionHistoryTrigger = /* GraphQL */ `
  query importExclusionHistoryTrigger(
    $metadata: String,
    $excluding: Boolean
  ) {
    importExclusionHistoryTrigger(
      metadata: $metadata,
      excluding: $excluding
    )
  }
`;

export const bulkImport = /* GraphQL */ `
  query bulkImport($input: BulkImportInput!) {
    bulkImport(input: $input) {
      executionId
      status
    }
  }
`;

export const databricksTableDataFetch = /* GraphQL */ `
  query databricksTableDataFetch(
    $queryType: String,
    $clients: [String]
  ) {
    databricksTableDataFetch(
      queryType: $queryType,
      clients: $clients
    )
  }
`;

export const databricksRunJob = /* GraphQL */ `
  query databricksRunJob($jobParameters: AWSJSON) {
    databricksRunJob(jobParameters: $jobParameters)
  }
`;


export const filesDotComTrigger = /* GraphQL */ `
  query filesDotComTrigger($input: String!) {
    filesDotComTrigger(
      input: $input
    )
  }
`;

export const batchEditCodes = /* GraphQL */ `
  query BatchEditCodes($input: String) {
    batchEditCodes(
      input: $input
    )
  }
`;

export const getTokenTC = /* GraphQL */ `
  query GetTokenTC($input: String) {
    getTokenTC(
      input: $input
    )
  }
`;

export const exportTrigger = /* GraphQL */ `
  query ExportTrigger($input: String) {
    exportTrigger(
      input: $input
    )
  }
`;

export const getDatalakeHistory = /* GraphQL */ `
  query GetDatalakeHistory($sync_name: ID!) {
    getDatalakeHistory(sync_name: $sync_name) {
      sync_name
      last_updated_version
      last_updated_startTime
      last_updated_endTime
    }
  }
`;

export const getClient = /* GraphQL */ `
  query GetClient($client_id: ID!) {
    getClient(client_id: $client_id) {
      client_id
      client_full_name
      jira_project_name
      client_type
      is_active
      is_advantage_member
      is_strategy_partner
      is_mid_level_member
      exclude_from_match_qualifier
      featurize
      people_platform
      action_platform
      transaction_platform
      exhaust_platform
      sms_shortcode_platform
      sms_longcode_platform
      transactions_offline_platform
      multichannel_transactions_platform
      curate_subscriber
      curate_frequency
      curate_days
      curate_delivery_auto_upload
      suppressed_domains
      actblue_entity_ids
      sfg_surveys_client_ids
      goop_client_ids
      totem_client_ids
      salsa_organization_key
      ngp_everyaction_database_name
      ngp_everyaction_server_name
      numero_account_ids
      salesforce_location
      pardot_location
      hub_source_path
      facebook_account_ids
      facebook_locations
      google_account_ids
      bing_account_ids
      twitter_account_ids
      outbrain_account_ids
      code_dictionary_url
      annelewis_slack_channel
      timezone
      mailchimp_directory
      classy_org_id
      ngp_actblue_manual_codes
      share_cap_max_shares
      share_cap_months
      hubspot_stitch_integration_name
      tatango_client_ids
      inbox_monster_rule
      campaign_monitor_location
      pause_data
      email_validation_provider
      multi_member_clients
      multi_member_sms_clients
      multi_member_mid_level_clients
      stw_subaccount_ids
      stw_non_coop_subaccount_ids
      switchboard_shortcode_dataset_name
      switchboard_longcode_dataset_name
      notes
      is_low_inventory
      fiscal_year_start
      multi_member_required
      multi_member_mid_level_required
      sector
      vendor
      email_configurations
      sms_configurations
      reactivation_configurations
      is_ads_reporting_active
      ads_configuration
      ads_commissions
      identity
      expanded_window
      is_advantage_member_timestamp
      createdAt
      updatedAt
    }
  }
`;
export const listClients = /* GraphQL */ `
  query ListClients(
    $client_id: ID
    $filter: ModelClientFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listClients(
      client_id: $client_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        client_id
        client_full_name
        jira_project_name
        client_type
        is_active
        is_advantage_member
        is_strategy_partner
        is_mid_level_member
        exclude_from_match_qualifier
        featurize
        people_platform
        action_platform
        transaction_platform
        exhaust_platform
        sms_shortcode_platform
        sms_longcode_platform
        transactions_offline_platform
        multichannel_transactions_platform
        curate_subscriber
        curate_frequency
        curate_days
        curate_delivery_auto_upload
        suppressed_domains
        actblue_entity_ids
        sfg_surveys_client_ids
        goop_client_ids
        totem_client_ids
        salsa_organization_key
        ngp_everyaction_database_name
        ngp_everyaction_server_name
        numero_account_ids
        salesforce_location
        pardot_location
        hub_source_path
        facebook_account_ids
        facebook_locations
        google_account_ids
        bing_account_ids
        twitter_account_ids
        outbrain_account_ids
        code_dictionary_url
        annelewis_slack_channel
        timezone
        mailchimp_directory
        classy_org_id
        ngp_actblue_manual_codes
        share_cap_max_shares
        share_cap_months
        hubspot_stitch_integration_name
        tatango_client_ids
        inbox_monster_rule
        campaign_monitor_location
        pause_data
        email_validation_provider
        multi_member_clients
        multi_member_sms_clients
        multi_member_mid_level_clients
        stw_subaccount_ids
        stw_non_coop_subaccount_ids
        switchboard_shortcode_dataset_name
        switchboard_longcode_dataset_name
        notes
        is_low_inventory
        fiscal_year_start
        multi_member_required
        multi_member_mid_level_required
        sector
        vendor
        email_configurations
        sms_configurations
        reactivation_configurations
        is_ads_reporting_active
        ads_configuration
        ads_commissions
        identity
        expanded_window
        is_advantage_member_timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const searchTimeStamps = /* GraphQL */ `
  query SearchTimeStamps(
    $filter: SearchableTimeStampsFilterInput
    $sort: [SearchableTimeStampsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableTimeStampsAggregationInput]
  ) {
    searchTimeStamps(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        client_id
        column_name
        changed_to
        changed_by
        id
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const sourceBySource = /* GraphQL */ `
  query SourceBySource(
    $source: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSourcesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sourceBySource(
      source: $source
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        client_id
        channel_category
        channel
        source
        from_goop
        send_date
        send_cost
        send_size
        updatedAt
      }
      nextToken
    }
  }
`;
export const searchSources = /* GraphQL */ `
  query SearchSources(
    $filter: SearchableSourcesFilterInput
    $sort: [SearchableSourcesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableSourcesAggregationInput]
  ) {
    searchSources(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        createdAt
        client_id
        channel_category
        channel
        source
        from_goop
        send_date
        send_cost
        send_size
        codes {
          items {
            id
            createdAt
            client_id
            code
            source
            fixed_cost_media_spend
            fixed_cost_cpa_override
            revenue_category
            audience
            audience_category
            type
            platforms_with_spend
            total_spend
            most_recent_spend
            most_recent_spend_date
            most_recent_transaction_date
            revenue
            transactions
            acquisitions
            most_recent_acquisition_date
            from_goop
            updatedAt
            page
            actblue_managing_entities
            channel_category
            channel
            send_cost
            send_size
            version
            jira_ticket_num
          }
          nextToken
        }
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const codesByCode = /* GraphQL */ `
  query CodesByCode(
    $code: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCodesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    codesByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        client_id
        code
        source
        channel
        channel_category
        send_cost
        send_size
        fixed_cost_media_spend
        fixed_cost_cpa_override
        revenue_category
        audience
        audience_category
        type
        platforms_with_spend
        total_spend
        most_recent_spend
        most_recent_spend_date
        most_recent_transaction_date
        revenue
        transactions
        acquisitions
        most_recent_acquisition_date
        from_goop
        updatedAt
        page
        actblue_managing_entities
        version
        jira_ticket_num
      }
      nextToken
    }
  }
`;
export const codesBySource = /* GraphQL */ `
  query CodesBySource(
    $source: String!
    $code: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCodesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    codesBySource(
      source: $source
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        client_id
        code
        source
        channel
        channel_category
        send_cost
        send_size
        fixed_cost_media_spend
        fixed_cost_cpa_override
        revenue_category
        audience
        audience_category
        type
        platforms_with_spend
        total_spend
        most_recent_spend
        most_recent_spend_date
        most_recent_transaction_date
        revenue
        transactions
        acquisitions
        most_recent_acquisition_date
        from_goop
        updatedAt
        page
        actblue_managing_entities
        version
        jira_ticket_num
      }
      nextToken
    }
  }
`;
export const searchCodes = /* GraphQL */ `
  query SearchCodes(
    $filter: SearchableCodesFilterInput
    $sort: [SearchableCodesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCodesAggregationInput]
  ) {
    searchCodes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        createdAt
        client_id
        code
        source
        channel
        channel_category
        send_cost
        send_size
        fixed_cost_media_spend
        fixed_cost_cpa_override
        revenue_category
        audience
        audience_category
        type
        platforms_with_spend
        total_spend
        most_recent_spend
        most_recent_spend_date
        most_recent_transaction_date
        revenue
        transactions
        acquisitions
        most_recent_acquisition_date
        from_goop
        updatedAt
        page
        actblue_managing_entities
        version
        jira_ticket_num
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const searchTransactions = /* GraphQL */ `
  query SearchTransactions(
    $filter: SearchableTransactionsFilterInput
    $sort: [SearchableTransactionsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableTransactionsAggregationInput]
  ) {
    searchTransactions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        client_id
        email
        code
        code_source {
          items {
            source
          }
        }
        amount
        transaction_dt
        recurring_period
        recurrence
        recurring_type
        refund_flag
        exclude_flag
        exclusion_updated_dt
        foreign_platform
        foreign_client_key
        foreign_transaction_key
        mobile_flag
        updated_dt
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const searchInsightsAcqDeliveries = /* GraphQL */ `
  query SearchInsightsAcqDeliveries(
    $filter: SearchableInsightsAcqDeliveriesFilterInput
    $sort: [SearchableInsightsAcqDeliveriesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInsightsAcqDeliveriesAggregationInput]
  ) {
    searchInsightsAcqDeliveries(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        Break_even_date
        Days_to_break_even
        Projected_break_even_date
        Projected_days_to_break_even
        ROAS
        ROAS_Over_Days
        Unsubs
        average_gift
        category
        click_emails
        click_rate
        clicks
        client
        client_type
        contributions
        contributions_over_sends
        donors
        emails_acquired
        emails_messaged
        first_delivery_date
        first_uploaded_date
        gifts_over_opens
        hard_bounce_emails
        hard_bounce_rate
        hard_bounces
        jira_ticket_num
        open_emails
        open_rate
        opens
        optout_emails
        optout_rate
        optouts
        pixel_load_emails
        pixel_load_rate
        pixel_loads
        revenue
        sends
        soft_bounce_emails
        soft_bounce_rate
        soft_bounces
        spam_emails
        spam_rate
        spams
        spend
        delivery_month
        delivery_year
        cost_per_donor
        send_emails_past_30
        updated_dt
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const searchInsightsAcqDeliveriesCohorts = /* GraphQL */ `
  query SearchInsightsAcqDeliveriesCohorts(
    $filter: SearchableInsightsAcqDeliveriesCohortFilterInput
    $sort: [SearchableInsightsAcqDeliveriesCohortSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInsightsAcqDeliveriesCohortAggregationInput]
  ) {
    searchInsightsAcqDeliveriesCohorts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        Break_even_date
        Days_to_break_even
        Projected_break_even_date
        Projected_days_to_break_even
        ROAS
        ROAS_Over_Days
        Unsubs
        average_gift
        category
        click_emails
        click_rate
        clicks
        client
        client_type
        cohort
        cohort_name
        contributions
        contributions_over_sends
        donors
        emails_acquired
        emails_messaged
        first_delivery_date
        first_uploaded_date
        gifts_over_opens
        hard_bounce_emails
        hard_bounce_rate
        hard_bounces
        jira_ticket_num
        open_emails
        open_rate
        opens
        optout_emails
        optout_rate
        optouts
        pixel_load_emails
        pixel_load_rate
        pixel_loads
        revenue
        sends
        soft_bounce_emails
        soft_bounce_rate
        soft_bounces
        spam_emails
        spam_rate
        spams
        spend
        delivery_month
        delivery_year
        cost_per_donor
        send_emails_past_30
        updated_dt
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const searchInsightsAdvDeliveries = /* GraphQL */ `
  query SearchInsightsAdvDeliveries(
    $filter: SearchableInsightsAdvDeliveriesFilterInput
    $sort: [SearchableInsightsAdvDeliveriesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInsightsAdvDeliveriesAggregationInput]
  ) {
    searchInsightsAdvDeliveries(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        Break_even_date
        Days_to_break_even
        Projected_break_even_date
        Projected_days_to_break_even
        ROAS
        ROAS_Over_Days
        Unsubs
        average_gift
        category
        click_emails
        click_rate
        clicks
        client
        client_type
        contributions
        contributions_over_sends
        donors
        emails_acquired
        emails_messaged
        first_delivery_date
        first_uploaded_date
        gifts_over_opens
        hard_bounce_emails
        hard_bounce_rate
        hard_bounces
        jira_ticket_num
        open_emails
        open_rate
        opens
        optout_emails
        optout_rate
        optouts
        pixel_load_emails
        pixel_load_rate
        pixel_loads
        revenue
        sends
        soft_bounce_emails
        soft_bounce_rate
        soft_bounces
        spam_emails
        spam_rate
        spams
        spend
        delivery_month
        delivery_year
        cost_per_donor
        send_emails_past_30
        updated_dt
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const searchInsightsAdvDeliveriesCohorts = /* GraphQL */ `
  query SearchInsightsAdvDeliveriesCohorts(
    $filter: SearchableInsightsAdvDeliveriesCohortFilterInput
    $sort: [SearchableInsightsAdvDeliveriesCohortSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInsightsAdvDeliveriesCohortAggregationInput]
  ) {
    searchInsightsAdvDeliveriesCohorts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        Break_even_date
        Days_to_break_even
        Projected_break_even_date
        Projected_days_to_break_even
        ROAS
        ROAS_Over_Days
        Unsubs
        average_gift
        category
        click_emails
        click_rate
        clicks
        client
        client_type
        cohort
        cohort_name
        contributions
        contributions_over_sends
        donors
        emails_acquired
        emails_messaged
        first_delivery_date
        first_uploaded_date
        gifts_over_opens
        hard_bounce_emails
        hard_bounce_rate
        hard_bounces
        jira_ticket_num
        open_emails
        open_rate
        opens
        optout_emails
        optout_rate
        optouts
        pixel_load_emails
        pixel_load_rate
        pixel_loads
        revenue
        sends
        soft_bounce_emails
        soft_bounce_rate
        soft_bounces
        spam_emails
        spam_rate
        spams
        spend
        delivery_month
        delivery_year
        cost_per_donor
        send_emails_past_30
        updated_dt
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const searchInsightsReacDeliveries = /* GraphQL */ `
  query SearchInsightsReacDeliveries(
    $filter: SearchableInsightsReacDeliveriesFilterInput
    $sort: [SearchableInsightsReacDeliveriesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInsightsReacDeliveriesAggregationInput]
  ) {
    searchInsightsReacDeliveries(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        Break_even_date
        Days_to_break_even
        Projected_break_even_date
        Projected_days_to_break_even
        ROAS
        ROAS_Over_Days
        Unsubs
        average_gift
        category
        click_emails
        click_rate
        clicks
        client
        client_type
        contributions
        contributions_over_sends
        donors
        emails_acquired
        emails_messaged
        first_delivery_date
        first_uploaded_date
        gifts_over_opens
        hard_bounce_emails
        hard_bounce_rate
        hard_bounces
        jira_ticket_num
        open_emails
        open_rate
        opens
        optout_emails
        optout_rate
        optouts
        pixel_load_emails
        pixel_load_rate
        pixel_loads
        revenue
        sends
        soft_bounce_emails
        soft_bounce_rate
        soft_bounces
        spam_emails
        spam_rate
        spams
        spend
        delivery_month
        delivery_year
        cost_per_donor
        send_emails_past_30
        updated_dt
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const searchInsightsReacDeliveriesCohorts = /* GraphQL */ `
  query SearchInsightsReacDeliveriesCohorts(
    $filter: SearchableInsightsReacDeliveriesCohortFilterInput
    $sort: [SearchableInsightsReacDeliveriesCohortSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInsightsReacDeliveriesCohortAggregationInput]
  ) {
    searchInsightsReacDeliveriesCohorts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        Break_even_date
        Days_to_break_even
        Projected_break_even_date
        Projected_days_to_break_even
        ROAS
        ROAS_Over_Days
        Unsubs
        average_gift
        category
        click_emails
        click_rate
        clicks
        client
        client_type
        cohort
        cohort_name
        contributions
        contributions_over_sends
        donors
        emails_acquired
        emails_messaged
        first_delivery_date
        first_uploaded_date
        gifts_over_opens
        hard_bounce_emails
        hard_bounce_rate
        hard_bounces
        jira_ticket_num
        open_emails
        open_rate
        opens
        optout_emails
        optout_rate
        optouts
        pixel_load_emails
        pixel_load_rate
        pixel_loads
        revenue
        sends
        soft_bounce_emails
        soft_bounce_rate
        soft_bounces
        spam_emails
        spam_rate
        spams
        spend
        delivery_month
        delivery_year
        cost_per_donor
        send_emails_past_30
        recurring_flag
        updated_dt
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const importHistoryByClient = /* GraphQL */ `
  query ImportHistoryByClient(
    $client: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelImportHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    importHistoryByClient(
      client: $client
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        s3_key
        client
        csv_name
        upload_type
        upload_results
        timestamp
        error
        warning
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const sumBySourceExportResultsByClientID = /* GraphQL */ `
  query SumBySourceExportResultsByClientID(
    $client_id: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSumBySourceExportResultsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sumBySourceExportResultsByClientID(
      client_id: $client_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        client_id
        run_config
        status
        s3_key
        signed_s3_url
        errors
        saved_dt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
